import { useTranslation } from 'react-i18next';
import { ClientOrgBadge } from '@/components/ClientOrgBadge';
import { cn } from '@/lib/utils';
import { audienceLabel } from '../lib/base-garments-audience';

export interface ReservedForBadgeProps {
  /** The client the blank is labelled for; null while the roster loads or when it is not connected. */
  clientName: string | null;
  className?: string;
}

/**
 * The stock type badge of a blank labelled for one client (F25): the client's
 * monogram and "Labelled for Mini Zali" ("Labelled for a client" while the name
 * is unknown). One badge for Base garments, Products and Inventory, so labelled
 * stock looks the same wherever it is listed. Capped at 16rem; a long client
 * name truncates, with the full words in the title.
 */
export function ReservedForBadge({ clientName, className }: ReservedForBadgeProps) {
  const { t } = useTranslation('inventory');
  const label = audienceLabel(t, 'client', clientName);
  return (
    <span title={label} className={cn('inline-flex min-w-0 max-w-[16rem]', className)}>
      <ClientOrgBadge
        orgName={clientName || t('baseGarments.who.aClient')}
        label={label}
        srLabel={label}
        className="min-w-0 max-w-full"
      />
    </span>
  );
}
